module.exports = __webpack_public_path__ + "img/onEmitter.c4db0db6.png";